//客服中心模块路由
import service from "./SERVICE_DATA";
//首页模块路由
import home from "./HOME_DATA";
//个人中心模块路由
import account from "./ACCOUNT_DATA";
//用户模块路由
import user from "./USER_DATA";
// 注销
import cancellation from "./CANCELLATION_DATA";
// 发票
import invoice from "./INVOICE_DATA";
import {
  ServiceLayout,
  BlankLayout,
  BasicLayout,
  CancellationLayout
} from "@/layouts";
// 各大模块 value 中的键值不能与system重复,千万不要重复，不然会有报错的
let layoutModuleList = [
  {
    system: "cancellation",
    value: cancellation,
    layoutInfo: {
      layoutName: CancellationLayout,
      redirect: "cancellationAccount"
    }
  },
  {
    system: "service",
    value: service,
    layoutInfo: {
      layoutName: ServiceLayout,
      redirect: "gameHome"
    }
  },
  {
    system: "home",
    value: home,
    layoutInfo: {
      layoutName: BlankLayout,
      redirect: "index"
    }
  },
  {
    system: "account",
    value: account,
    layoutInfo: {
      layoutName: BasicLayout,
      redirect: "profile"
    }
  },
  {
    system: "user",
    value: user,
    layoutInfo: {
      layoutName: BasicLayout,
      redirect: "login"
    }
  },
  {
    system: "invoice",
    value: invoice,
    layoutInfo: {
      layoutName: BasicLayout,
      redirect: "invoiceRules"
    }
  }
];

let routerList = [],
  objList = {};
//设置路由信息
if (layoutModuleList.length > 0) {
  layoutModuleList.forEach(item => {
    setCompentInfo(item.system, item.value);
    item.value = setCompentLayout(item);
    let objItem = { ...item.value };
    Object.assign(objList, objItem);
  });
}

routerList = Object.values(objList);
//设置组件信息
function setCompentInfo(system, value) {
  Object.keys(value).forEach(item => {
    value[item] = {
      ...value[item],
      name: item,
      meta: {
        title: value[item].title,
        parent: system,
        back: value[item].back,
        requiresAuth: value[item].requiresAuth || false
      },
      path: setPath(system, item),
      component: () => {
        return importCompent(system, value[item]);
      }
    };
  });
}
//设置路径名称
function setPath(system, item) {
  let path = "";
  item != "gameHome" ? (path = `/${item}`) : (path = `/${system}/index`);
  return path;
}
//引入组件
function importCompent(system, item) {
  if (system == "home") {
    return import(/* webpackChunkName: "home" */ `@/view/home/${
      item.componentPath
    }`);
  } else if (system == "user") {
    return import(/* webpackChunkName: "user" */ `@/view/user/${
      item.componentPath
    }`);
  } else if (system == "account") {
    return import(/* webpackChunkName: "account" */ `@/view/account/${
      item.componentPath
    }`);
  } else if (system == "service") {
    return import(/* webpackChunkName: "service" */ `@/view/service/${
      item.componentPath
    }`);
  } else if (system == "cancellation") {
    return import(/* webpackChunkName: "cancellation" */ `@/view/cancellation/${
      item.componentPath
    }`);
  } else if (system == "invoice") {
    return import(/* webpackChunkName: "invoice" */ `@/view/invoice/${
      item.componentPath
    }`);
  }
}
//设置组件Layout
function setCompentLayout(item) {
  return {
    ...item.value,
    [item.system]: {
      name: item.system,
      path: `/${item.system}`,
      meta: {
        parent: undefined
      },
      component: item.layoutInfo.layoutName,
      redirect:
        item.layoutInfo.redirect && item.value[item.layoutInfo.redirect].path
    }
  };
}
let allRouter = filterRouter(routerList);
//数组递归为树结构
function filterRouter(data, parent) {
  let tree = [];
  if (data.length > 0) {
    data.forEach(item => {
      if (item.meta.parent === parent) {
        item.children = filterRouter(data, item.name);
        tree.push(item);
      }
    });
  }

  return tree;
}

export const ANCHOR_DATA = {
  ...service,
  ...home,
  ...user,
  ...account,
  ...cancellation,
  ...invoice
};
export const ROUTER_DATA = allRouter;
